<template>
  <div>
    <breadcrumb-bar :crumbs="[{name:'Groups'},{name:'Activities and Services'}]"></breadcrumb-bar>
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="portlet light">
              <div class="portlet-title">
                <div class="caption caption-md">
                  <span class="caption-subject bold uppercase">Activities and Services</span>
                </div>
                <span class="pull-right options-gear" @click.prevent="columnsModalShow()" v-if="user.access >= 5 && step === 2"><i class="icon-settings right"></i></span>
                <groups-forms-columns id="groups-forms-columns" @confirmed="saveParticipantColumns"/>
                <div v-if="step === 3" class="selected-info">
                  {{ selected.length }} participant<span v-if="selected.length > 1">s</span> selected
                </div>
              </div>
              <div class="portlet-body">
                <ul class="list-group" v-if="step === 1">
                  <li class="list-group-item" v-for="form in forms">
                    <h4 class="pull-left">{{ form.name }}</h4>
                    <button class="btn green pull-right" @click.stop="selectParticipants(form.id)">
                      <i class="fa fa-check-square-o" aria-hidden="true"></i>
                      Complete Form
                    </button>
                    <div class="clearfix"></div>
                  </li>
                </ul>
                <div v-if="step === 2">
                  <form role="form" class="form-horizontal" @submit.prevent="search">
                    <div class="form-group form-md-line-input has-warning">
                      <div class="col-md-12">
                        <div class="input-group">
                          <div class="input-group-control input-icon">
                            <i class="fa fa-search"></i>
                            <input type="text" placeholder="Type to search..." class="form-control" v-model="searchQuery">
                            <div class="form-control-focus"></div>
                          </div>
                          <span class="input-group-btn btn-right">
                        <button type="submit" data-style="expand-left"
                                class="btn green mt-ladda-btn ladda-button search-btn-submit-pd">
                          <span class="ladda-label">Search</span>
                        </button>
                      </span>
                        </div>
                      </div>
                    </div>
                  </form>

                  <div class="vue-good-table" v-if="((participants.length > 0) || filterActive) && serverColumns.length">
                    <vue-good-table
                        :columns="columns"
                        :rows="participants"
                        :pagination-options="{
                      enabled: true,
                        perPageDropdown: [10, 20, 50, 100, 200, 500],
                        dropdownAllowAll: true,
                        perPage: this.serverParams.perPage
                      }"
                        mode="remote"
                        :totalRows="totalRecords"
                        @on-page-change="onPageChange"
                        @on-sort-change="onSortChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"

                    >
                      <template slot="table-column" slot-scope="props">
                        <label class="mt-checkbox mt-checkbox-outline" v-if="props.column.label == 'All'">
                          <input type="checkbox" v-model="selectAll"/>
                          <span></span>
                        </label>
                        <span v-else>
                          {{ props.column.label }}
                        </span>
                      </template>

                      <template slot="table-row" slot-scope="props">
                        <template v-if="props.column.field=='before'">
                          <label class="mt-checkbox mt-checkbox-outline">
                            <input type="checkbox" :value="props.row.id" @click="selectRow" :checked="selected.includes(props.row.id)" :disabled="props.row.disabled"/>
                            <span></span>
                          </label>
                        </template>
                        <template v-else><span :class="{'disabled' : props.row.disabled}">{{props.formattedRow[props.column.field]}}</span></template>
                      </template>

                    </vue-good-table>
                  </div>
                  <div class="not-found-results" v-else>
                    <h4>Sorry, no search results were found.</h4>
                    <h5>Search Suggestions:</h5>
                    <ul>
                      <li>Check your spelling</li>
                      <li>Search by {{ participantSingularName }} Name, System ID or Organization ID</li>
                    </ul>
                  </div>
                  <button class="btn green pull-left" @click.stop="selectForm()">
                    Back
                  </button>
                  <button class="btn green pull-right" @click.stop="completeForm()" v-if="selected.length > 0">
                    Next
                  </button>
                </div>
                <div v-if="step === 3">
                  <vue-form-render ref="formRender"
                                   :schema="form.schema"
                                   :conditions="form.conditions"
                                   :calculations="form.calculations"
                                   :values="form.values"
                                   :date-format="user.date_format"
                                   :user-access-level="user.access"
                                   :validation-conditions="form.extra_validation_rules"
                                   :hideValues="form.hide_values"
                                   :form-previews="form.form_previews"
                                   name="widgetForm"></vue-form-render>
                  <button class="btn green pull-left" @click.stop="selectParticipants()">
                    Back
                  </button>
                  <button data-style="expand-left"
                          class="btn green pull-right mt-ladda-btn ladda-button groups-btn-submit"
                          @click.prevent="submit()">
                    <span class="ladda-label">Submit</span>
                  </button>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs'
  import Spinner from '@/components/Spinner'
  import VueFormRender from '@/components/formbuilder/VueFormRender'
  import GroupsFormsColumns from "../components/modals/GroupsFormsColumns";
  import {HTTP} from '@/http-common'
  import {mapActions, mapGetters, mapMutations} from 'vuex'
  import participantDisplayName from '@/mixins/participantDisplayName';

  export default {
    mixins: [
      participantDisplayName
    ],
    data() {
      return {
        searchQuery: '',
        serverParams: {
          columnFilters: {},
          sort: {
            field: '',
            type: '',
          },
          page: 1,
          perPage: 10
        },
        filterActive: false,
        formId: null
      }
    },
    components: {
      'breadcrumb-bar': Breadcrumbs,
      'vue-spinner': Spinner,
      'vue-form-render': VueFormRender,
      GroupsFormsColumns
    },
    created() {
      this.SET_COLUMNS([]);
      this.setGroupsStep(1);
      this.getGroupsFormsAction();
      this.setGroupsSelectedAll([]);
    },
    computed: {
      ...mapGetters({
        step: 'getGroupsStep',
        forms: 'getGroupsFormsInOrder',
        form: 'getGroupsForm',
        participants: 'getGroupsParticipants',
        selected: 'getGroupsSelected',
        loadingSearch: 'getGroupsLoadingSearch',
        totalRecords: 'getGroupsParticipantsResultsCount',
        user: 'getUser',
        serverColumns: 'getGroupsColumns'
      }),
      selectAll: {
        get: function () {
          return this.participants.length !== 0 && (this.participants.length === this.selected.length)
        },
        set: function (value) {
          if (value) {
            let items = []
            this.participants.forEach(function (item) {
              if(!item.disabled) {
                items.push(item.id)
              }
            })
            this.setGroupsSelectedAll(items)
          } else {
            this.setGroupsSelectedAll([])
          }
        }
      },
      columns() {
        let serverColumns = [...this.serverColumns];
        serverColumns.unshift(
          {
            label: 'All',
            field: 'before',
            sortable: false
          }
        )

        serverColumns.map(item => {
          if(item.hasOwnProperty('key') && item.key.startsWith('cf')) {
            item.sortable = false;
          }
        })

        return serverColumns;
      }
    },
    methods: {
      ...mapActions({
        setGroupsStep: 'SET_GROUPS_STEP_ACTION',
        getGroupsFormsAction: 'GET_GROUPS_FORMS_ACTION',
        getGroupsFormAction: 'GET_GROUPS_FORM_ACTION',
        getGroupsParticipantsAction: 'GET_GROUPS_PARTICIPANTS_ACTION',
        updateGroupsSelected: 'UPDATE_GROUPS_SELECTED_ACTION',
        setGroupsSelectedAll: 'SET_GROUPS_SELECTED_ALL_ACTION',
        saveGroupsForm: 'SAVE_GROUPS_FORM_ACTION'
      }),
      ...mapMutations([
        'SET_COLUMNS'
      ]),
      selectForm() {
        this.setGroupsStep(1)
      },
      selectParticipants(formId) {
        this.formId = formId;
        this.getParticipantList();
        this.getGroupsFormAction(formId);
        this.setGroupsStep(2)
      },
      completeForm() {
        this.setGroupsStep(3)
      },
      submit() {
        const formComponent = this.$refs.formRender;

        formComponent.submit().then(results => {
          if (results.isValid) {
            const data = {
              data: results.fields,
              elements: this.selected,
              form_id: this.form.id
            }

            let context = Ladda.create(document.querySelector('.groups-btn-submit'));
            context.start();
            // TODO: add support for saving files
            this.saveGroupsForm(data).finally(() => {
              context.stop();
            })
          }
        })
      },
      selectRow(event) {
        this.updateGroupsSelected(parseInt(event.srcElement.value))
      },
      search() {
        this.getGroupsParticipantsAction({
            keyword: this.searchQuery,
            form_id: this.formId,
            notdismissed: true,
            ignorewithemptystatus: true,
            context: 'groups_forms',
          }
        ).then(response => {
          console.log(response);
        });
      },
      getParticipantList() {
        if(!this.formId) {
          return [];
        }

        this.getGroupsParticipantsAction({
          notdismissed: true,
          ignorewithemptystatus: true,
          limit: this.serverParams.perPage,
          current_page: this.serverParams.page,
          sort_by: this.serverParams.sort.field,
          sort_order: this.serverParams.sort.type,
          columns_filter: this.serverParams.columnFilters,
          form_id: this.formId,
          context: 'groups_forms'
        });
      },

      updateParams(newProps) {
        this.serverParams = Object.assign({}, this.serverParams, newProps);
      },

      onPageChange(params) {
        this.updateParams({page: params.currentPage});
        this.getParticipantList();
      },

      onPerPageChange(params) {
        this.updateParams({perPage: params.currentPerPage, page: 1});
        this.getParticipantList();
      },

      onSortChange(params) {
        this.updateParams({
          sort: {
            type: params[0].type,
            field: params[0].field
          },
        });
        this.getParticipantList();
      },

      onColumnFilter(params) {
        this.filterActive = true;
        this.updateParams(params);
        this.getParticipantList();
      },

      columnsModalShow() {
        $('#groups-forms-columns').modal('show');
      },

      saveParticipantColumns(columns) {
        HTTP.post(`participant-directory-columns/save`, {
          columns: JSON.stringify(columns),
          context: 'groups_forms'
        })
          .then(response => {
            this.SET_COLUMNS([]);
            this.getParticipantList()
          }).catch(err => {
          console.log(err);
        });
      },
    },
    watch: {
      loadingSearch(newValue) {
        let el = document.querySelector('.search-btn-submit-pd');
        if (el !== null) {
          const button = Ladda.create(el);
          newValue === true ? button.start() : button.stop()
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .vue-good-table {
    margin-bottom: 20px;
    td span.disabled {
      color: #ccc;
    }
  }

  .form-name {
    padding-top: 0;
    margin-top: 0;
    margin-bottom: 20px;
  }

  .selected-info {
    float: right;
    line-height: 18px;
    margin: 10px 0;
    color: #666;
  }

  .list-group-item {
    margin-bottom: 20px;
  }

  .options-gear {
    display: inline-block;
    padding: 10px 5px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// GroupsForms.vue?4b886837